import React from "react";
import { Popover, OverlayTrigger } from "react-bootstrap";

import StatusFilter from "./StatusFilter";
import DateFilter from "./DateFilter";
import SortBy from "./SortBy";

class SortFilterPopover extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showPopover: false,
      hasChanges: false,
      justReset: false,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClear = this.handleClear.bind(this);
    this.handleToggle = this.handleToggle.bind(this);
    this.trackChanges = this.trackChanges.bind(this);
  }

  componentDidUpdate(prevProps) {
    // Track if any filter values have changed
    if (
      prevProps.sortBy !== this.props.sortBy ||
      prevProps.dateFilterStart !== this.props.dateFilterStart ||
      prevProps.dateFilterEnd !== this.props.dateFilterEnd ||
      JSON.stringify(prevProps.filterStatuses) !== JSON.stringify(this.props.filterStatuses)
    ) {
      if (!this.state.justReset && !this.state.hasChanges) {
        this.setState({ hasChanges: true });
      }
    }
  }

  handleSubmit() {
    // Only search if there are changes and it wasn't just reset
    if (this.state.hasChanges || !this.state.justReset) {
      this.props.handleSearch();
    }

    // Close the popover after filtering
    this.setState({ showPopover: false, hasChanges: false, justReset: false });
  }

  handleClear() {
    this.props.handleFilterClear();
    
    // Mark that we just reset, so Filter button won't trigger reload
    this.setState({ hasChanges: false, justReset: true });
  }

  handleToggle(nextShow) {
    // If popover is closing and there are unsaved changes (and didn't just reset), submit
    if (!nextShow && this.state.showPopover && this.state.hasChanges && !this.state.justReset) {
      this.props.handleSearch();
    }
    
    // Reset the flags when closing
    this.setState({ 
      showPopover: nextShow,
      hasChanges: nextShow ? this.state.hasChanges : false,
      justReset: nextShow ? this.state.justReset : false
    });
  }

  trackChanges() {
    this.setState({ hasChanges: true, justReset: false });
  }
  
  render() {
    const { showPopover } = this.state;

    const active =
      this.props.sortBy !== "Date Ordered" ||
      this.props.dateFilterStart ||
      this.props.dateFilterEnd ||
      Object.values(this.props.filterStatuses).includes(true)
        ? "active-btn"
        : "";

    const popover = (
      <Popover id="popover-sort-filter">
        <Popover.Body>
          <SortBy
            sortBy={this.props.sortBy}
            handleInputChange={(name, value) => {
              this.trackChanges();
              this.props.handleInputChange(name, value);
            }}
          />
          <DateFilter
            dateFilterStart={this.props.dateFilterStart}
            dateFilterEnd={this.props.dateFilterEnd}
            handleInputChange={(name, value) => {
              this.trackChanges();
              this.props.handleInputChange(name, value);
            }}
            sortBy={this.props.sortBy}
            width={this.props.width}
          />
          <StatusFilter
            filterStatuses={this.props.filterStatuses}
            onFilterChange={(status, value) => {
              this.trackChanges();
              this.props.onFilterChange(status, value);
            }}
            handleSearch={this.props.handleSearch}
          />

          <div className="d-flex pt-4 justify-content-between">
            <button
              className="filter-popover-action filter-btn"
              type="button"
              onClick={this.handleSubmit}
            >
              Filter
            </button>
            <button
              className="filter-popover-action"
              type="button"
              onClick={this.handleClear}
            >
              Reset
            </button>
          </div>
        </Popover.Body>
      </Popover>
    );

    return (
      <OverlayTrigger
        trigger="click"
        rootClose
        placement="bottom"
        overlay={popover}
        show={showPopover}
        onToggle={this.handleToggle}
      >
        <button className={`new-btn filter-popover ${active}`}>
          <i className="fas fa-filter"></i> Sort & Filter
        </button>
      </OverlayTrigger>
    );
  }
}

export default SortFilterPopover;